import { mountStoreDevtool } from 'simple-zustand-devtools'
import { StatusProposta } from 'types/gravaAdesaoAPI'
import { create } from 'zustand'
import { combine, createJSONStorage, persist } from 'zustand/middleware'

type ContratoInfoType = {
  downloadInfo: {
    title: string
    file: string | null
    fileType: string | null
  }
  processedProposal: {
    isAco: boolean
    id_concc030: number
    id_documento: number
    sn_assinatura_digital: string
    sn_pode_emitir_boleto: string
    propostasCarrinho: PropostasCarrinho[]
  }
}
type PropostasCarrinho = {
  id_documento: number
  id_tipo_documento: number
}

export interface PostGravaAdesaoAPIResponse {
  notifications: Notification[]
}

export interface GetConsultarPropostaAPIResponse {
  data: ContratoInfo | StatusProposta
  notifications: Notification[]
}
export interface ContratoInfo {
  id_agrupamento_venda?: number
  st_status_proposta?: string
  st_analise_credito?: string
  id_documento?: number
  mensagem?: string
  sn_pode_emitir_boleto?: string
  sn_pode_efetuar_debito?: string
  propostascarrinho?: Propostascarrinho[]
  id_concc030?: number | string
  sn_assinatura_digital?: string
}

export interface Propostascarrinho {
  id_documento: number
  id_tipo_documento: number
  id_empresa?: number
  cd_bem?: string
  nm_bem?: string
  cd_produto?: string
  cd_segmento_bem?: string
}

const DEFAULT_CONTRATO_INFO: ContratoInfoType = {
  processedProposal: {} as ContratoInfoType['processedProposal'],
  downloadInfo: {
    title: '',
    file: null,
    fileType: null
  }
}

const useContratoInfoStore = create(
  persist(
    combine(DEFAULT_CONTRATO_INFO, (set) => ({
      setProcessedProposal: (processedProposal: ContratoInfoType['processedProposal']) =>
        set({ processedProposal }),
      setDownloadInfo: (downloadInfo: { title: string; file: string; fileType: string }) =>
        set({ downloadInfo }),

      resetContratoInfo: () => set(DEFAULT_CONTRATO_INFO)
    })),
    {
      name: 'contrato-info',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Contrato Store', useContratoInfoStore)
}

export default useContratoInfoStore
